import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemText,
  Alert,
  Box,
  Typography,
} from "@mui/material";
import { cardOutline, fonts, semiBoldFonts } from "../../../Styles/Styles";
import LoadingAnimation from "../../Animations/LoadingAnimation";

export default function CategoriesFilter() {
  const [categories, setCategories] = useState([]);
  const [isLoadingCategories, setIsLoadingCategories] = useState(false);
  const [categoriesError, setCategoriesError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      setIsLoadingCategories(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_SERVER_BASE_URL}/categories`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch categories");
        }
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
        setCategoriesError(
          "Unable to load categories. Please try again later."
        );
      } finally {
        setIsLoadingCategories(false);
      }
    };

    fetchCategories();
  }, []);

  return (
    <Box
      sx={{
        p: 2,
        mb: 5,
        borderRadius: "8px",
        ...cardOutline,
      }}
    >
      <Typography variant="h6" gutterBottom sx={{ ...semiBoldFonts }}>
        Categories
      </Typography>
      {/* Error alert */}
      {categoriesError && (
        <Alert severity="error" sx={{ my: 2 }}>
          {categoriesError}
        </Alert>
      )}

      {/* Loading spinner */}
      {isLoadingCategories && <LoadingAnimation />}

      {/* Categories List */}
      <List>
        {categories.map((category, index) => (
          <ListItem
            button
            key={index}
            component={Link}
            to={category.slug}
            sx={{
              color: "#212529", // Default text color for all items
              height: 30,
              "&.active": {
                // Styling for the active link state
                color: "var(--primary-color)",
                fontWeight: "bold",
              },
              "&:hover": {
                // Optional hover style
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            }}
          >
            <ListItemText
              primary={
                <Typography sx={{ ...fonts }}>{category.label}</Typography>
              }
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
